import React from 'react';

interface COTagProps {
  label: string;
  children: React.ReactNode;
  variant?: 'default' | 'brand' | 'secondary' | 'caption';
  className?: string;
}

const COTag: React.FC<COTagProps> = ({
  label,
  children,
  variant = 'default',
  className = '',
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'brand':
        return 'bg-content-brand text-white px-2 py-1';
      case 'secondary':
        return 'bg-content-secondary text-white px-2 py-1';
      case 'caption':
        return 'text-content-secondary text-xs font-normal tracking-[0.24px] px-0 py-0';
      default:
        return 'bg-content-brandMedium text-content-brand px-2 py-1';
    }
  };

  const renderContent = () => {
    if (variant === 'caption') {
      return (
        <span className="text-content-secondary font-normal">
          {label} {children}
        </span>
      );
    }

    return (
      <>
        <span className="text-content-secondary font-normal">{label}</span>
        <span className="text-content-brand font-medium">{children}</span>
      </>
    );
  };

  return (
    <span
      className={`
        inline-flex
        items-center
        gap-1
        rounded
        text-xs
        font-normal
        font-dm-sans
        tracking-[-0.12px]
        ${getVariantClasses()}
        ${className}
      `}
    >
      {renderContent()}
    </span>
  );
};

export default COTag;